export const ActiveState = {
    ACTIVE: 0,
    PAUSED: 1,
    INACTIVE: 2
}

export const getStateName = (activeState) => {
    if(activeState === ActiveState.ACTIVE){
        return "Active"
    }else if(activeState === ActiveState.PAUSED){
        return "Paused"
    }else if(activeState === ActiveState.INACTIVE){
        return "Not Active"
    }else{
        return ""
    }
}